import type { MarlinStoreDb } from "../infra/db";
import * as ops from "./store";

export const createOffsetsApi = (db: MarlinStoreDb) => ({
  getSubscriptionOffset: (
    machineId: Parameters<typeof ops.getSubscriptionOffset>[1],
    topic: Parameters<typeof ops.getSubscriptionOffset>[2],
  ) => ops.getSubscriptionOffset(db, machineId, topic),
  setSubscriptionOffset: (
    machineId: Parameters<typeof ops.setSubscriptionOffset>[1],
    topic: Parameters<typeof ops.setSubscriptionOffset>[2],
    offset: Parameters<typeof ops.setSubscriptionOffset>[3],
  ) => ops.setSubscriptionOffset(db, machineId, topic, offset),
  getAllSubscriptionOffsets: () => ops.getAllSubscriptionOffsets(db),
});

export type OffsetsApi = ReturnType<typeof createOffsetsApi>;
